import { packIntoFormData } from "../utilities/apiUtilities";
import axiosInstance from "../auth/axioInstance";

const controllerUrl = `/user`

function indexUsers({
    sortOrder = "", 
    searchString = "", 
    pageSize = 50, 
    pageNumber = 1
}) {
    return axiosInstance.get(`${controllerUrl}`, { params: {sortOrder: sortOrder, searchString: searchString, pageSize: pageSize, pageNumber: pageNumber}});
}

function getUser(id) {
    return axiosInstance.get(`${controllerUrl}/${id}`);
}

function updateUserProfile(id, userProfileUpdateViewModel) {
    return axiosInstance.put(`${controllerUrl}/${id}`, packIntoFormData(userProfileUpdateViewModel), { headers: { 'Content-Type': "multipart/form-data"} });
}

function deleteUser(id) {
    let formData = new FormData();
    formData.append("id", id);

    return axiosInstance.post(`${controllerUrl}?id=${id}`, formData, { headers: { 'Content-Type': "application/json"} });
}

export const userService = {
    indexUsers,
    getUser,
    updateUserProfile,
    deleteUser
}